import React, { useContext, useEffect, useState } from "react";
import MUICard from "../../components/MUICard/MUICard.component";
import {
  Typography,
  Avatar,
  IconButton,
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import { AppGlobalContext } from "../../contexts/AppContext.context";
import { Icons } from "../../config/MuiIcons.config";
import { AppTheme } from "../../theme/App.theme";
import { useNavigate } from "react-router-dom";
import useLogoutHook from "../../hook/useLogoutHook";
import UpdateOrDeleteProfile from "./components/UpdateOrDeleteProfile";
import MUIDrawer from "../../components/MUIDrawer/MUIDrawer";

const UserProfile = () => {
  const navigate = useNavigate();
  const { authUserDetails } = useContext(AppGlobalContext);
  const { handleUserLogout } = useLogoutHook();
  const [profileDetails, setProfileDetails] = useState({
    name: "",
    email: "",
    profileImage: "",
  });

  // Drawer Functionality
  const [drawer, setDrawer] = useState({
    isOpen: false,
    data: null,
  });

  const handleDrawerToggle = (
    isOpen = false,
    data = null,
  ) => {
    setDrawer({
      isOpen: isOpen,
      data: data,
    });
  };

  useEffect(() => {
    if (authUserDetails && authUserDetails?.uid) {
      const { email, firstName, lastName, profileImage } = authUserDetails;
      setProfileDetails({
        email: email || "Not Available",
        name: `${firstName} ${lastName}` || "Not Available",
        profileImage: profileImage || "",
      });
    }
  }, [authUserDetails]);

  const { email, name, profileImage } = profileDetails;

  const handleShare = async () => {
    try {
      const shareData = {
        title: "Hindus R Us",
        text: "Explore a vast collection of Hindu scriptures, teachings, and devotional content.",
        url: window.location.origin,
      };
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(shareData.url);
      }
    } catch (_) {}
  };

  const primaryMenus = [
    // { label: "About Us", to: null, IconComp: Icons.InfoOutlineIcon },
    { label: "FAQ's", to: "/faq", IconComp: Icons.HelpOutline },
    {
      label: "Testimonial",
      to: "/testimonial",
      IconComp: Icons.SpeakerNotesOutlined,
    },
    { label: "Contact Us", to: "/contact-us", IconComp: Icons.Email },
    // { label: "Discussion Forum", to: null, IconComp: Icons.GroupIcon },
    // { label: "Donate", to: null, IconComp: Icons.RupeeIcon },
    {
      label: "Share App",
      to: null,
      IconComp: Icons.OpenInNewIcon,
      onClick: handleShare,
    },
    { label: "Privacy Policy", to: "/privacy", IconComp: Icons.LockOutlinedIcon },
    { label: "Delete Account Instructions", to: "/delete-account-instruction", IconComp: Icons.Trash },
  ];

  const renderMenuList = (items) => (
    <List disablePadding>
      {items.map(({ label, to, IconComp, onClick }, idx) => (
        <Box key={label}>
          <ListItemButton
            disableRipple
            onClick={() => (onClick ? onClick() : to ? navigate(to) : null)}
          >
            <ListItemIcon sx={{ minWidth: 40, color: AppTheme.PRIMARY_BLACK }}>
              <IconComp fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {label}
                </Typography>
              }
            />
            <Icons.RightArrowAngleIcon sx={{ color: "text.disabled" }} />
          </ListItemButton>
          {idx < items.length - 1 && <Divider color="disabled" />}
        </Box>
      ))}
    </List>
  );

  return (
    <React.Fragment>
      <div>
        <MUIDrawer
          open={drawer?.isOpen}
          onClose={() => handleDrawerToggle(false, null)}
          title={"Edit Profile"}
        >
          <UpdateOrDeleteProfile
            Data={drawer?.data || {}}
            CloseDrawer={() => handleDrawerToggle(false, null)}
          />
        </MUIDrawer>

        <MUICard className={"mb-3"}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2.5,
              flexWrap: "wrap",
              width: "100%",
            }}
          >
            <IconButton style={{ color: AppTheme.PRIMARY_COLOR, padding: 0 }}>
              {profileImage ? (
                <Avatar
                  src={profileImage}
                  alt={name}
                  sx={{
                    width: { xs: 56, sm: 64, md: 72 },
                    height: { xs: 56, sm: 64, md: 72 },
                  }}
                />
              ) : (
                <Icons.UserProfileIcon
                  sx={{
                    width: { xs: 56, sm: 64, md: 72 },
                    height: { xs: 56, sm: 64, md: 72 },
                  }}
                />
              )}
            </IconButton>

            <Box sx={{ minWidth: 220, flexGrow: 1 }}>
              <Typography variant="h6">{name}</Typography>
              <Typography variant="body2" color="text.secondary">
                {email}
              </Typography>
              <Typography
                className="cursor-pointer mt-1"
                sx={{
                  color: AppTheme.PRIMARY_COLOR,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.75,
                }}
                onClick={() => {
                  handleDrawerToggle(true, {...authUserDetails})
                }}
              >
                <Icons.ModeEditOutlineOutlinedIcon fontSize="small" />
                Edit Profile
              </Typography>
            </Box>

            <Box
              sx={{
                marginLeft: { xs: 0, sm: "auto" },
                width: "auto",
                display: "flex",
                alignItems: "center",
                gap: 0.75,
                cursor: "pointer",
                color: AppTheme.PRIMARY_COLOR,
              }}
              onClick={handleUserLogout}
              aria-label="Log out"
            >
              <Icons.LogoutIcon fontSize="small" />
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Log-Out
              </Typography>
            </Box>
          </Box>
        </MUICard>

        <MUICard className={"mb-3"} removeDefaultPadding padding={0}>
          {renderMenuList(primaryMenus)}
        </MUICard>
      </div>
    </React.Fragment>
  );
};

export default UserProfile;
